import React, { lazy, useCallback, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { isMobile } from "react-device-detect";
import FederatedModule from "./Components/FederatedModule";
import CacheInitializer from "./Utils/CacheInitializer";
const Themes = lazy(() =>
  isMobile ? import("./Components/Themes") : import("./pages/Index"),
);
const InfoPage = lazy(() => import("./pages/InfoPage"));

// import Chatbot from "./Components/AI/Chatbot";

const Index = lazy(() =>
  isMobile ? import("./pages/IndexMobile") : import("./pages/Index"),
);

const FunctionalTheme = lazy(() => import("./Components/FunctionalTheme"));

const ContactUs = lazy(() => import("./pages/ContactUs"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const StakeholderAck = lazy(() => import("./pages/StakeholderAck"));
const Sitemap = lazy(() => import("./pages/Sitemap"));
const PageNotFound = lazy(() => import("./pages/404"));
const UnderConstruction = lazy(() => import("./pages/UnderConstruction"));
const Search = lazy(() => import("./pages/Search"));

export default function App() {
  const [isWpCacheReady, setIsWpCacheReady] = useState(false);

  const onWpCacheReady = useCallback(() => {
    setIsWpCacheReady(true);
  }, []);

  const renderThemeRoute = (theme) =>
    isWpCacheReady && (
      <FunctionalTheme theme={theme} />
    ) 

  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <CacheInitializer onReady={onWpCacheReady} />
      <FederatedModule />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="Index" element={<Index />} />

        {/* <Route path="Themes" element={<Themes />} /> */}
        <Route path="Health/:source" element={renderThemeRoute("Health")} />
        {/* <Route path="WomenEmpowerment/:source" element={<WomenEmpowerment />} /> */}
        <Route
          path="Environment/:source"
          element={renderThemeRoute("Environment")}
        />
        <Route
          path="CultureAndHeritage/:source"
          element={renderThemeRoute("CultureAndHeritage")}
        />
        <Route
          path="TelecomAndSpace/:source"
          element={renderThemeRoute("TelecomAndSpace")}
        />
        <Route
          path="Education/:source"
          element={renderThemeRoute("Education")}
        />
        <Route path="Energy/:source" element={renderThemeRoute("Energy")} />
        <Route
          path="CommunityEmpowerment/:source"
          element={renderThemeRoute("CommunityEmpowerment")}
        />
        <Route
          path="Population/:source"
          element={renderThemeRoute("Population")}
        />
        <Route path="Economy/:source" element={renderThemeRoute("Economy")} />
        <Route
          path="FutureHorizon/:source"
          element={renderThemeRoute("FutureHorizon")}
        />
        <Route
          path="RegionalAndInternationalContext/:source"
          element={renderThemeRoute("RegionalAndInternationalContext")}
        />
        <Route
          path="MapsAndGazetteer/:source"
          element={renderThemeRoute("MapsAndGazetteer")}
        />
        <Route
          path="Transportation/:source"
          element={renderThemeRoute("Transportation")}
        />
        <Route path="Themes" element={<Themes />} />
        <Route path="InfoPage" element={<InfoPage />} />
        <Route path="ContactUs" element={<ContactUs />} />
        <Route path="Disclaimer" element={<Disclaimer />} />
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="StakeholderAck" element={<StakeholderAck />} />
        <Route path="Sitemap" element={<Sitemap />} />
        <Route path="404" element={<PageNotFound />} />
        <Route path="UnderConstruction" element={<UnderConstruction />} />
        <Route path="Search/:source" element={<Search />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
